import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      getDoc: 'db/doc'
    })
  },
  methods: {
    ...mapActions({
      dbsave: 'db/save',
      saveDocs: 'db/bulkDocs'
    }),
    saveDoc (db, doc) {
      const payload = Object.assign({ db }, doc)
      return this.dbsave(payload)
    }
  }
}
